import { primaryMenuItems, standaloneNavItems } from '@/components/layout/AppSidebar';
import {
  buildUrlIdEntries,
  resolveIdFromEntries,
  isRouteAllowed,
  firstGrantedPathFrom,
} from './menuPermissions.core';

const ENTRIES = buildUrlIdEntries(standaloneNavItems as any, primaryMenuItems as any);

export function resolveMenuPermissionId(pathname: string): string | null {
  return resolveIdFromEntries(pathname, ENTRIES);
}

export function isMenuRouteAllowed(pathname: string, menuPermissions: string[]): boolean {
  return isRouteAllowed(pathname, ENTRIES, menuPermissions);
}

export function firstGrantedPath(menuPermissions: string[]): string {
  return firstGrantedPathFrom(primaryMenuItems as any, menuPermissions);
}
